import { inject, Injectable } from '@angular/core';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UnleashClient } from 'unleash-proxy-client';
import { AccountService } from '@easy-lib/modules/account-activity';
import { filter, map, take } from 'rxjs/operators';
import { UnleashFeatures } from '@easy-lib/modules/shared/models/unleash.model';

@Injectable({
	providedIn: 'root'
})
export class UnleashService extends BaseService {
	private accountService = inject(AccountService);
	private unleash: UnleashClient;
	private unleashReady = new BehaviorSubject<boolean>(null);
	private unleashReady$ = this.unleashReady.asObservable();

	constructor() {
		super();
		this.unleash = new UnleashClient({
			url: this.environment.unleash.url,
			appName: this.environment.unleash.appName,
			clientKey: this.environment.unleash.clientKey,
			refreshInterval: this.environment.unleash.refreshInterval,
			environment: this.environment.unleash.environment
		});

		this.setUnleashStatus();
	}
	init() {
		this.accountService.userAccountInfo$
			.pipe(
				filter(info => !!info?.customerIsin),
				take(1)
			)
			.subscribe(userInfo => {
				this.unleash.setContextField('userId', userInfo.customerIsin);
				this.unleash.start();
			});
	}

	isFeatureEnabled$(featureName: UnleashFeatures): Observable<boolean> {
		return this.unleashReady$.pipe(
			map(ready => {
				if (ready === true) {
					return this.unleash.isEnabled(featureName);
				} else if (ready === false) {
					return false;
				}
			}),
			filter(a => [false, true].includes(a))
		);
	}
	isFeatureEnabled(featureName: UnleashFeatures): boolean {
		return this.unleash.isEnabled(featureName);
	}
	private setUnleashStatus() {
		this.unleash.on('update', () => {
			this.unleashReady.next(true);
		});
		this.unleash.on('error', () => {
			this.unleashReady.next(false);
		});
	}
}
